/**
 * useResponsive Hook
 * Custom hook for responsive design and breakpoint detection
 */

import { useTheme, useMediaQuery } from '@mui/material';

export const useResponsive = () => {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  const isMobile = isXs;
  const isTablet = isSm || isMd;
  const isDesktop = isLg || isXl;

  const up = {
    sm: useMediaQuery(theme.breakpoints.up('sm')),
    md: useMediaQuery(theme.breakpoints.up('md')),
    lg: useMediaQuery(theme.breakpoints.up('lg')),
    xl: useMediaQuery(theme.breakpoints.up('xl'))
  };

  const down = {
    xs: useMediaQuery(theme.breakpoints.down('xs')),
    sm: useMediaQuery(theme.breakpoints.down('sm')),
    md: useMediaQuery(theme.breakpoints.down('md')),
    lg: useMediaQuery(theme.breakpoints.down('lg'))
  };

  const between = {
    xsSm: useMediaQuery(theme.breakpoints.between('xs', 'sm')),
    smMd: useMediaQuery(theme.breakpoints.between('sm', 'md')),
    mdLg: useMediaQuery(theme.breakpoints.between('md', 'lg')),
    lgXl: useMediaQuery(theme.breakpoints.between('lg', 'xl'))
  };

  return {
    // Current breakpoint
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,

    // Device type
    isMobile,
    isTablet,
    isDesktop,

    // Breakpoint helpers
    up,
    down,
    between,

    // Current breakpoint name
    breakpoint: isXs ? 'xs' : isSm ? 'sm' : isMd ? 'md' : isLg ? 'lg' : 'xl'
  };
};

export default useResponsive; 